import React from 'react';
import { observer } from 'mobx-react';
import { TagCategoryStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class TagCategoryCreate extends React.Component {

  onCreate = name => {
    const data = {
      name,
      group_id: this.props.groupId,
    };
    TagCategoryStore.create({data}, this.props.afterChange);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Enter Tag Category Name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default TagCategoryCreate;
